import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';
export function useDocumentTitle(title) {
    useIsomorphicLayoutEffect(() => {
        window.document.title = title;
    }, [title]);
}
